<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="d-none d-sm-block navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-dark.png" alt height="20"/>
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="28"/>
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
               <img src="@/assets/images/logo-light.png" alt height="20"/>
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt height="28"/>
            </span>
          </router-link>
        </div>

        <button
            id="vertical-menu-btn"
            type="button"
            class="btn btn-sm px-3 font-size-16 header-item"
            @click="toggleMenu">
          <i class="fa fa-fw fa-bars"></i>
        </button>
        <!--
        <form class="app-search d-none d-lg-block">
          <div class="position-relative">
            <input
              type="text"
              class="form-control"
              placeholder="Pesquisar"
            />
            <span class="bx bx-search-alt"></span>
          </div>
        </form>
        -->
      </div>

      <div class="d-flex">
        <p v-show="isLoading" class="mb-0 mt-3">
          <i class="bx bx-loader mt-1 bx-spin font-size-24 align-middle mr-2"></i>
        </p>
        <multiselect
            v-if="empresas && empresas.length > 0"
            v-model="curretEmpresa"
            track-by="pes_nome"
            label="pes_nome"
            :allowEmpty="false"
            placeholder="Pesquise por código, razão social, nome fantasia ou CNPJ"
            :show-labels="false"
            @select="selectEmpresa"
            :close-on-select="true"
            :options="list_empresas"
            @search-change="pesquisarEmpresas"
            :searchable="true"
            :internal-search="false"
            :openDirection="'bottom'"
            :tagPosition="'bottom'"
            class="mt-3">
          <template slot="option" slot-scope="props">
            <div class="option__desc">
          <span class="option__title">
            <b>Código: </b>{{ props.option.eco_codigo }}
            <br><b>Razão Social: </b>{{ props.option.pes_nome }}
            <br><b>Nome Fantasia: </b>{{ props.option.eco_nome_fantasia }}
            <br><b>CNPJ: </b>
            <span v-if="props.option.pes_cpfcnpj.length < 12">{{
                props.option.pes_cpfcnpj | VMask('###.###.###-##')
              }}</span>
            <span v-else>{{ props.option.pes_cpfcnpj | VMask('##.###.###/####-##') }}</span>
            <br><b>Tipo de Empresa: </b>{{ props.option.tab_103classificacao | tipoPessoa }}
            <br><b>Tributação Especial: </b>{{ props.option.eco_tributacao | tributacaoPessoa }}
          </span>
            </div>
          </template>
          <span slot="noOptions">Faça a pesquisa por código, razão social, nome fantasia ou CNPJ</span>
          <span slot="noResult">Empresa não localizada ou não liberada para o seu usuário.
          <br> Informe Código, Razão Social, Nome Fantasia ou CNPJ
          </span>
        </multiselect>
        <div v-else class="mt-3">
          <input type="text" disabled value="Sem Empresa Liberada" class="form-control font-weight-bold is-invalid">
          <div class="invalid-feedback">Faça a solicitação e aguarde a liberação</div>
        </div>
        <p class="mb-0 d-none d-md-block">
          <timer></timer>
        </p>
        <!--
                <b-dropdown
                    class="d-inline-block d-lg-none ml-2"
                    variant="black"
                    menu-class="dropdown-menu-lg p-0"
                    toggle-class="header-item noti-icon" right>
                  <template v-slot:button-content>
                    <i class="mdi mdi-magnify"></i>
                  </template>

                  <form class="p-3">
                    <div class="form-group m-0">
                      <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Search ..."
                            aria-label="Recipient's username"
                        />
                        <div class="input-group-append">
                          <button class="btn btn-primary" type="submit">
                            <i class="mdi mdi-magnify"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </b-dropdown>

                <b-dropdown
                  right
                  menu-class="dropdown-menu-lg p-0"
                  toggle-class="header-item noti-icon"
                  variant="black">
                  <template v-slot:button-content>
                    <i class="bx bx-bell bx-tada"></i>
                    <span class="badge badge-danger badge-pill">{{
                      $t("navbar.dropdown.notification.badge")
                    }}</span>
                  </template>

                  <div class="p-3">
                    <div class="row align-items-center">
                      <div class="col">
                        <h6 class="m-0">
                          {{ $t("navbar.dropdown.notification.text") }}
                        </h6>
                      </div>
                      <div class="col-auto">
                        <a href="#" class="small">{{
                          $t("navbar.dropdown.notification.subtext")
                        }}</a>
                      </div>
                    </div>
                  </div>
                  <simplebar style="max-height: 230px">
                    <a href="javascript: void(0);" class="text-reset notification-item">
                      <div class="media">
                        <div class="avatar-xs mr-3">
                          <span
                            class="avatar-title bg-primary rounded-circle font-size-16"
                          >
                            <i class="bx bx-cart"></i>
                          </span>
                        </div>
                        <div class="media-body">
                          <h6 class="mt-0 mb-1">
                            {{ $t("navbar.dropdown.notification.order.title") }}
                          </h6>
                          <div class="font-size-12 text-muted">
                            <p class="mb-1">
                              {{ $t("navbar.dropdown.notification.order.text") }}
                            </p>
                            <p class="mb-0">
                              <i class="mdi mdi-clock-outline"></i>
                              {{ $t("navbar.dropdown.notification.order.time") }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </a>
                    <a href="javascript: void(0);" class="text-reset notification-item">
                      <div class="media">
                        <img
                          src="@/assets/images/users/avatar-3.jpg"
                          class="mr-3 rounded-circle avatar-xs"
                          alt="user-pic"
                        />
                        <div class="media-body">
                          <h6 class="mt-0 mb-1">
                            {{ $t("navbar.dropdown.notification.james.title") }}
                          </h6>
                          <div class="font-size-12 text-muted">
                            <p class="mb-1">
                              {{ $t("navbar.dropdown.notification.james.text") }}
                            </p>
                            <p class="mb-0">
                              <i class="mdi mdi-clock-outline"></i>
                              {{ $t("navbar.dropdown.notification.james.time") }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </a>
                    <a href="javascript: void(0);" class="text-reset notification-item">
                      <div class="media">
                        <div class="avatar-xs mr-3">
                          <span
                            class="avatar-title bg-success rounded-circle font-size-16"
                          >
                            <i class="bx bx-badge-check"></i>
                          </span>
                        </div>
                        <div class="media-body">
                          <h6 class="mt-0 mb-1">
                            {{ $t("navbar.dropdown.notification.item.title") }}
                          </h6>
                          <div class="font-size-12 text-muted">
                            <p class="mb-1">
                              {{ $t("navbar.dropdown.notification.item.text") }}
                            </p>
                            <p class="mb-0">
                              <i class="mdi mdi-clock-outline"></i>
                              {{ $t("navbar.dropdown.notification.item.time") }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </a>
                    <a href="javascript: void(0);" class="text-reset notification-item">
                      <div class="media">
                        <img
                          src="@/assets/images/users/avatar-4.jpg"
                          class="mr-3 rounded-circle avatar-xs"
                          alt="user-pic"
                        />
                        <div class="media-body">
                          <h6 class="mt-0 mb-1">
                            {{ $t("navbar.dropdown.notification.salena.title") }}
                          </h6>
                          <div class="font-size-12 text-muted">
                            <p class="mb-1">
                              {{ $t("navbar.dropdown.notification.salena.text") }}
                            </p>
                            <p class="mb-0">
                              <i class="mdi mdi-clock-outline"></i>
                              {{ $t("navbar.dropdown.notification.salena.time") }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </a>
                  </simplebar>
                  <div class="p-2 border-top">
                    <a class="btn btn-sm btn-light btn-block text-center"
                      href="javascript:void(0)">
                      <i class="mdi mdi-arrow-down-circle mr-1"></i>
                      {{ $t("navbar.dropdown.notification.button") }}
                    </a>
                  </div>
                </b-dropdown>
                -->
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <img
                :title="user.pes_nome"
                class="rounded-circle header-profile-user"
                src="@/assets/images/users/user-default.png"
                :alt="user.pes_nome"
            />
            <span class="d-none d-xl-inline-block ml-1">
              {{ user.pes_nome | partName }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item
          <b-dropdown-item>
            <router-link tag="span" to="/contacts/profile">
              <i class="bx bx-user font-size-16 align-middle mr-1"></i>
              Perfil
            </router-link>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>-->
          <a href="/" @click="logoutUser"
             class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
            Sair
          </a>
        </b-dropdown>
        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
              type="button"
              class="btn header-item noti-icon"
              @click="initFullScreen">
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>
        <div class="dropdown d-inline-block">
          <button
              type="button"
              class="btn header-item noti-icon right-bar-toggle toggle-right"
              @click="toggleRightSidebar">
            <i class="bx bx-cog toggle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Timer from "@/components/widgets/timer"
import {authComputed, authMethods} from "@/state/helpers";
import store from "@/state/store";
import {autocompleteEmpresas} from "@/api/geral/autocomplete";

/**
 * Nav-bar Component
 */
export default {
  components: {
    Timer,
    Multiselect
  },
  data() {
    return {
      isLoading: false,
      user: null,
      curretEmpresa: null,
      list_empresas: [],
      empresas: [],
    };
  },
  computed: {
    ...authComputed
  },
  created() {
    this.user = this.$store.state.auth.currentUser;
    this.curretEmpresa = this.$store.state.auth.currenEmpresa;
    if (this.$store.state.auth.empresasLiberadas) {
      this.empresas = this.$store.state.auth.empresasLiberadas;
      this.list_empresas = this.$store.state.auth.empresasLiberadas;
    }
  },
  methods: {
    ...authMethods,
    selectEmpresa(empresa) {
      store.dispatch('auth/listEmpresa', this.list_empresas).then(() => {
        this.setCurrentEmpresa(empresa)
      });
    },
    setCurrentEmpresa(empresa) {
      if (empresa) {
        this.empresaAtual(empresa).catch(() => {
        }).finally(() => {
        })
      }
    },
    pesquisarEmpresas(search) {
      if (search && search.length > 1) {
        this.isLoading = true;
        autocompleteEmpresas({query: search}).then(response => {
          if (response.status) {
            if (response.dados) {
              this.list_empresas = response.dados
            }
          }
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.isLoading = false;
        })
      }
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
          !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
          !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    logoutUser() {
      this.logOut()
          .catch((erro) => {
            console.log(erro)
          }).finally(() => {
      })
    },
  },
};
</script>
<style>

.multiselect__input, .multiselect__single {
  font-weight: 600;
  font-size: 12px !important;
}

.multiselect__element {
  border-bottom: 1px #eff2f7 solid;
  font-size: 12px;
}

.option__title {
  word-wrap: break-word;
  white-space: normal;
}

.multiselect__placeholder {
  color: #000000 !important;
  font-weight: 600;
  font-size: 12px !important;
}
</style>
